const INITIAL_STATE = {};

const root = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        default:
            return state;
    }
};

export default root;
